/** Elapsed time is anchored to a recorded export or original record creation, never epoch zero. */
export function backupReminderDue(input: { count: number; lastExport: number | null; firstCreatedAt: number | null; dismissedAt: number | null; now: number }): boolean {
  const valid = (value: number | null): value is number => value != null && Number.isFinite(value) && value > 0 && value <= input.now;
  const since = valid(input.lastExport) ? input.lastExport : valid(input.firstCreatedAt) ? input.firstCreatedAt : null;
  return input.count >= 10 && since != null && input.now - since >= 30 * 86400000
    && (!valid(input.dismissedAt) || input.now - input.dismissedAt >= 14 * 86400000);
}
